<header >
  <div class="cvt-logo-iconleft "> <img src="../../../assets/logo_main.png" /> </div>
  <div class="cvt-logo-iconright ">

    <nav class="level1">
      <ul>
        <li><span href="#" class="first headerUserDisplayName">{{userDisplayName}}</span></li>
        <li><span href="#">{{customerName}}</span></li>
        <li class="headerBlueLink"><a [href]="helpUrl" target="_blank">Help &amp; Support</a></li>
        <li *ngIf="allowedToChangeCustomer" class="ri-header-customer-list">
          <kendo-dropdownlist
            #list
            [data]="customerSelectionList"
            [value]="customerSelect"
            [valuePrimitive]="false"
            [textField]="'text'"
            [valueField]="'value'"
            (selectionChange)="OnCustomerChanged($event)"
            [allowCustom]="false"
            [popupSettings]="customerDropdownPopupSettings">
            <ng-template kendoDropDownListValueTemplate>
              <span class="boldFont">Change Account</span>
            </ng-template>
            <ng-template kendoDropDownListItemTemplate let-dataItem>
              <span class="change-account-item">{{dataItem.text}}</span>
            </ng-template>
          </kendo-dropdownlist>

        </li>
        <li class="headerBlueLink"><a [href]="homeURL" id="homeLink">Home</a></li>
        <li class="headerBlueLink"><a (click)="logOut()">Log Out</a></li>
      </ul>
    </nav>
    <nav class="level2">
      <div>
        <span nglDropdown [(open)]="openBtnRateIntegrity">
          <button class="slds-button cvt-primary setPadding" nglDropdownTrigger>
            <span class="slds-truncate">Rate Integrity</span><span class="cvt-icon-spacing cvt-icon-down"></span>
          </button>
          <div class="slds-dropdown slds-dropdown--left dropdownStyling">
            <ul class="" role="menu">
              <li class="" *ngFor="let item of enabledProducts;">
                <a [routerLink]="[item.path]" role="menuitem" (click)="Click1(item)">
                  <p class="slds-truncate">{{item.text}}</p>
                </a>
              </li>
            </ul>
          </div>
        </span>
        <span nglDropdown [(open)]="openBtnAdministration">
          <button class="slds-button cvt-secondary setPadding" nglDropdownTrigger>
            <span class="slds-truncate">Administration</span><span class="cvt-icon-spacing cvt-icon-down"></span>
          </button>
          <div class="slds-dropdown slds-dropdown--left dropdownStyling">
            <ul class="" role="menu">
              <li class="" *ngFor="let item of enabledAdminAccess;">
                <a *ngIf="item.disabled !== true" [routerLink]="[item.path]" role="menuitem" (click)="openBtnAdministration = false;">
                  <p class="slds-truncate"><span *ngIf='item.indent'>&emsp;</span> {{item.text}}</p>
                </a>
                <p *ngIf="item.disabled === true" class="slds-truncate cvt-menu-header">{{item.text}}</p>
              </li>
            </ul>
          </div>
        </span>
        <span nglDropdown [(open)]="openBtnReports">
          <button class="slds-button cvt-tertiary  " [routerLink]="['reports/gds-usage-report']" >
            <span class="cvt-icon-contacts "></span><span class="cvt-icon-spacing "></span><span class="slds-truncate">Reports</span>
          </button>
        </span>
      </div>
    </nav>
  </div>
</header>
<div class="GdprMsg" *ngIf="showGDPRMsg">On May 23, 2018, we updated our<a href="https://www.lanyon.com/privacy-policy.shtml" target="_blank" >&nbsp;Privacy Policy&nbsp;</a>to, among other things, incorporate the changes required by the EU General Data Protection Regulation. We encourage you to read the entire updated<a href="https://www.lanyon.com/privacy-policy.shtml" target="_blank" >&nbsp;Privacy Policy</a>, which includes a summary of key updates.</div>

